import React, { useEffect, useState } from "react";

const icons = ["🍎","🍌","🍇","🍒","🍍","🥝","🍉","🍓"];

export default function MemoryGame() {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [lock, setLock] = useState(false);

  useEffect(() => {
    startGame();
  }, []);

  const startGame = () => {
    const shuffled = [...icons, ...icons]
      .sort(() => Math.random() - 0.5)
      .map((icon, index) => ({
        id: index,
        icon
      }));

    setCards(shuffled);
    setFlipped([]);
    setMatched([]);
  };

  const handleClick = (index) => {
    if (lock) return;
    if (flipped.includes(index)) return;
    if (matched.includes(index)) return;

    const newFlipped = [...flipped, index];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setLock(true);

      const [a, b] = newFlipped;

      if (cards[a].icon === cards[b].icon) {
        setMatched([...matched, a, b]);
        setFlipped([]);
        setLock(false);
      } else {
        setTimeout(() => {
          setFlipped([]);
          setLock(false);
        }, 700);
      }
    }
  };

  const isFlipped = (i) =>
    flipped.includes(i) || matched.includes(i);

  const isWin = matched.length === cards.length && cards.length > 0;

  return (
    <div className="memory">
      <h2>Memory Game</h2>

      <div className="grid">
        {cards.map((card, i) => (
          <div
            key={card.id}
            className={`card ${isFlipped(i) ? "flipped" : ""}`}
            onClick={() => handleClick(i)}
          >
            <div className="inner">
              <div className="front">?</div>
              <div className="back">{card.icon}</div>
            </div>
          </div>
        ))}
      </div>

      {isWin && <div className="win">🎉 You Win!</div>}

      <button className="restart" onClick={startGame}>
        Restart
      </button>
    </div>
  );
}